import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_7: FaireProductEntity = {
  token: "nyc-bev-7",
  type: "product",
  name: "Cold Pressed Green Juice",
  brandName: "Juice Lab NYC",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/83225eb332fd099df4377b239ff2c7695db66ef76052ebe99c9a7fca7b390396.webp",
  priceDollars: 8.5,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/83225eb332fd099df4377b239ff2c7695db66ef76052ebe99c9a7fca7b390396.webp",
  weight: 1.1,
  dimensions: {
    width: 3,
    height: 9,
    depth: 3,
  },
  description: "Fresh mint lemonade from Manhattan",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "organic"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
